import {
    ISortedItemIdNameType,
    ITemplateGroupEntityDTO,
    ItemType,
    SortedTemplateItem,
} from '@modeso/types__aumico-lib-templates-be';

export class SortingTemplateItemsHelper {
    public static mapGroupSortedItemsToSortedItem(group: ITemplateGroupEntityDTO): ITemplateGroupEntityDTO {
        const sortedItems = group.sortedItems;
        if (sortedItems == null) {
            group.sortedItems = [];
            group.groups.forEach((groupOfGroups) => {
                (group.sortedItems as SortedTemplateItem[]).push(groupOfGroups);
            });
            group.items.forEach((itemOfGroup) => {
                (group.sortedItems as SortedTemplateItem[]).push(itemOfGroup);
            });
            group.groups.forEach((grp) => {
                SortingTemplateItemsHelper.mapGroupSortedItemsToSortedItem(grp);
            });
        } else {
            let itemNameTypeToSortedMappingItemMap = new Map<string, SortedTemplateItem>();
            itemNameTypeToSortedMappingItemMap = SortingTemplateItemsHelper.getItemNameTypeToSortedTemplateItemMap(
                group,
                itemNameTypeToSortedMappingItemMap,
            );

            sortedItems.forEach((sortedItemIdType, index) => {
                const id = sortedItemIdType.type != ItemType.SUB_TOTAL ? sortedItemIdType._id : sortedItemIdType.name;
                const sortedItemKey = SortingTemplateItemsHelper.createKeyWithIdAndType(id, sortedItemIdType.type);
                const sortedMappingItem = itemNameTypeToSortedMappingItemMap.get(sortedItemKey);
                if (sortedMappingItem == null) {
                    throw new Error('sorted item name type does not exist');
                }
                sortedItems[index] = sortedMappingItem;
            });

            group.groups.forEach((group) => {
                this.mapGroupSortedItemsToSortedItem(group);
            });
        }
        return group;
    }

    //Preparing a map with sortedItems (NameType) to sortedItems (full object)
    private static getItemNameTypeToSortedTemplateItemMap(
        group: ITemplateGroupEntityDTO,
        itemNameTypeToSortedMappingItemMap: Map<string, SortedTemplateItem>,
    ): Map<string, SortedTemplateItem> {
        const groupSortedItemKey = SortingTemplateItemsHelper.createKeyWithIdAndType(
            group.groupRef._id,
            ItemType.GROUP,
        );

        itemNameTypeToSortedMappingItemMap.set(groupSortedItemKey, group);
        group.groups.forEach((group) => {
            SortingTemplateItemsHelper.getItemNameTypeToSortedTemplateItemMap(
                group,
                itemNameTypeToSortedMappingItemMap,
            );
        });

        group.items.forEach((item) => {
            const [type, id] = item.isSubtotal ? [ItemType.SUB_TOTAL, item.name] : [ItemType.FLI, item._id];
            const itemSortedItemKey = SortingTemplateItemsHelper.createKeyWithIdAndType(id, type);
            itemNameTypeToSortedMappingItemMap.set(itemSortedItemKey, item);
        });
        return itemNameTypeToSortedMappingItemMap;
    }

    private static createKeyWithIdAndType(_id: string, type: ItemType): string {
        return `${_id}-${type}`;
    }

    public static mapGroupSortedItemsToItemIdType(group: ITemplateGroupEntityDTO): ITemplateGroupEntityDTO {
        const sortedItems = group.sortedItems;
        if (sortedItems == null) {
            const groupsItemNameType: ISortedItemIdNameType[] = [];
            group.groups.forEach((innerGroup) => {
                groupsItemNameType.push({
                    _id: innerGroup.groupRef._id,
                    name: innerGroup.groupRef.name,
                    type: ItemType.GROUP,
                } as ISortedItemIdNameType);
            });
            group.items.forEach((item) => {
                const [type, id] = item.isSubtotal ? [ItemType.SUB_TOTAL, item.name] : [ItemType.FLI, item._id];
                groupsItemNameType.push({
                    name: item.name,
                    type,
                    _id: id,
                } as ISortedItemIdNameType);
            });
            group.sortedItems = groupsItemNameType;
            group.groups.forEach((grp) => {
                SortingTemplateItemsHelper.mapGroupSortedItemsToItemIdType(grp);
            });
        } else {
            const sortedMappingItems = sortedItems.map((sortedItem) => {
                return SortingTemplateItemsHelper.mapSortedTemplateItemToItemNameType(sortedItem);
            });

            group.sortedItems = sortedMappingItems;

            group.groups.forEach((group) => {
                SortingTemplateItemsHelper.mapGroupSortedItemsToItemIdType(group);
            });
        }
        return group;
    }

    private static mapSortedTemplateItemToItemNameType(sortedItem: SortedTemplateItem): ISortedItemIdNameType {
        let sortedMappingItemNameType: ISortedItemIdNameType;
        if (this.isTemplateGroup(sortedItem)) {
            sortedMappingItemNameType = {
                name: sortedItem.groupRef.name,
                _id: sortedItem.groupRef._id,
                type: ItemType.GROUP,
            };
        } else {
            const [type, id] = sortedItem.isSubtotal
                ? [ItemType.SUB_TOTAL, sortedItem.name]
                : [ItemType.FLI, sortedItem._id];
            sortedMappingItemNameType = {
                name: sortedItem.name,
                type,
                _id: id,
            };
        }

        return sortedMappingItemNameType;
    }

    public static isTemplateGroup(item: SortedTemplateItem): item is ITemplateGroupEntityDTO {
        return 'groups' in item || 'groupRef' in item;
    }
}
